import { SvgProps } from "@/utils/types";

export const MushroomAlt = ({
  primaryColor = "#D4DF65",
  secondaryColor = "#06B992",
  outlineColor = "#0E5654",
  className,
}: SvgProps) => (
  <svg
    width="28"
    height="33"
    className={className}
    viewBox="0 0 28 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_904_867)">
      <path
        d="M10.1557 17.8628C10.3088 21.3961 8.1883 27.8769 8.1883 27.8769C7.66097 29.7032 9.03117 31.5266 10.9287 31.5302L16.4232 31.5405C17.7137 31.5429 18.7887 30.6952 19.155 29.5459C19.3221 29.0095 19.2913 28.4345 19.107 27.9039C18.4906 26.101 16.4006 19.7273 17.0875 18.0227"
        fill={primaryColor}
      />
      <path
        d="M16.4267 32.7928L10.9323 32.7824C9.62892 32.78 8.4353 32.1836 7.65142 31.1407C6.86754 30.0978 6.62724 28.7813 6.98737 27.5297C7.01951 27.4275 9.04376 21.1829 8.90295 17.9179L11.4012 17.8076C11.5604 21.5263 9.46541 27.9944 9.37546 28.2625C9.24684 28.7095 9.3417 29.2272 9.6476 29.6367C9.9535 30.0461 10.4195 30.277 10.9306 30.278L16.4251 30.2883C17.1342 30.2896 17.7484 29.8372 17.9669 29.1667C18.044 28.9177 18.0318 28.6174 17.9302 28.3105C16.0049 22.6719 15.3345 19.0545 15.9315 17.5606L18.2553 18.4913C17.992 19.1936 18.6182 22.5937 20.2956 27.5036C20.5752 28.3219 20.5928 29.1589 20.355 29.9251C19.8087 31.6427 18.2284 32.7962 16.4267 32.7928Z"
        fill={outlineColor}
      />
      <path
        d="M2.5063 14.6348C4.49671 16.1974 7.14597 17.346 10.1542 17.8628C11.2911 18.0566 12.4792 18.161 13.7059 18.1633C14.9326 18.1657 16.1147 18.0657 17.2587 17.8697C20.2624 17.3707 22.9096 16.232 24.9187 14.6705C25.6417 14.1096 26.0076 13.1839 25.8048 12.2891C24.392 5.95497 19.526 1.28828 13.7376 1.2774C7.94926 1.26652 3.06575 5.91489 1.6291 12.25C1.42936 13.1441 1.78542 14.0648 2.5063 14.6348Z"
        fill={secondaryColor}
      />
      <path
        d="M13.7039 19.4092C12.4198 19.4068 11.155 19.3022 9.94146 19.0891C6.77355 18.5464 3.93913 17.34 1.73817 15.6172C0.628133 14.7462 0.113319 13.3141 0.416121 11.973C2.00743 4.92899 7.48562 0.0134036 13.7404 0.02516C19.9951 0.0369164 25.4548 4.96667 27.026 12.0166C27.3238 13.3653 26.7972 14.7954 25.6839 15.6622C23.4637 17.3895 20.6247 18.5788 17.4676 19.1032C16.2725 19.3118 15.0073 19.418 13.7103 19.4156L13.7039 19.4092ZM3.28161 13.6523C5.15719 15.1253 7.60223 16.1521 10.3677 16.6301C12.5265 17.0047 14.9288 17.0028 17.0442 16.6427C19.7987 16.1814 22.254 15.1638 24.1479 13.6915C24.5062 13.4175 24.6731 12.977 24.5844 12.5679C23.273 6.66842 18.8085 2.54555 13.7357 2.53601C8.66285 2.52648 4.18288 6.62615 2.84927 12.527C2.75907 12.9294 2.92434 13.3769 3.28161 13.6523Z"
        fill={outlineColor}
      />
      <path
        d="M19.6625 14.1239C20.34 14.1252 20.8902 13.577 20.8915 12.8996C20.8927 12.2221 20.3446 11.6719 19.6671 11.6706C18.9896 11.6693 18.4394 12.2175 18.4381 12.8949C18.4369 13.5724 18.985 14.1227 19.6625 14.1239Z"
        fill={outlineColor}
      />
      <path
        d="M19.2621 9.79788C19.9396 9.79915 20.4898 9.25098 20.4911 8.57351C20.4924 7.89604 19.9442 7.3458 19.2667 7.34453C18.5892 7.34326 18.039 7.89143 18.0377 8.5689C18.0365 9.24637 18.5846 9.79661 19.2621 9.79788Z"
        fill={outlineColor}
      />
      <path
        d="M15.7435 12.2765C16.421 12.2778 16.9713 11.7297 16.9725 11.0522C16.9738 10.3747 16.4256 9.82447 15.7482 9.8232C15.0707 9.82192 14.5205 10.3701 14.5192 11.0476C14.5179 11.725 15.0661 12.2753 15.7435 12.2765Z"
        fill={outlineColor}
      />
    </g>
    <defs>
      <clipPath id="clip0_904_867">
        <rect
          width="26.7761"
          height="32.7625"
          fill="white"
          transform="translate(0.349609) rotate(0.107692)"
        />
      </clipPath>
    </defs>
  </svg>
);
